import React, { useEffect, useRef } from 'react';
import styled from '@emotion/styled';
import { motion } from 'framer-motion';
import WaveField from '../../components/WaveField/WaveField';

// break out of any centered page container to span the full viewport width
const Fullscreen = styled(motion.div)`
  position: relative;
  width: 100vw;
  margin-left: calc(50% - 50vw);
`;

const Home = () => {
  const wrapRef = useRef(null);

  // fill the viewport from just below the header down to the bottom edge
  useEffect(() => {
    const el = wrapRef.current;
    const setHeight = () => {
      const top = el.getBoundingClientRect().top + window.scrollY;
      el.style.height = `${Math.max(window.innerHeight - top, 320)}px`;
    };
    setHeight();
    window.addEventListener('resize', setHeight);
    return () => window.removeEventListener('resize', setHeight);
  }, []);

  return (
    <Fullscreen
      ref={wrapRef}
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.8 }}
    >
      <WaveField />
    </Fullscreen>
  );
};

export default Home;
